import { PortionCount } from '@mindfulchefuk/config/portionCountConfig'
import errorHandler from '@mindfulchefuk/utils/errorHandler'
import axios, { AxiosResponse } from 'axios'

type TRecipeContent = {
  recipe_id: string
  portions: PortionCount
}

export type TOnboardingPreviewBody = {
  code_string: string
  delivery_date: string
  recipe_contents: TRecipeContent[]
}

type TAPICreateOnboardingPreviewResponse = {
  data: {
    attributes: {
      recipe_purchase_value: string
      recipe_external_payment_amount: string
      recipe_shipping_amount: string
      recipe_discount_amount: string
      recipe_standard_shipping_amount: string
    }
  }
}

export type TCreateOnboardingPreviewResponse = {
  recipePriceBeforeDiscount: string
  recipePriceWithDiscount: string
  shippingPrice: string
  discountedAmount: string
  regularShippingPrice: string
}

export const createOnboardingPreview = (
  onboardingPreviewPayload: TOnboardingPreviewBody
): Promise<TCreateOnboardingPreviewResponse> => {
  if (!onboardingPreviewPayload) {
    return undefined
  } else {
    return axios
      .post(
        `${process.env.NEXT_PUBLIC_API_URL}/payments/onboarding_order_previews`,
        {
          data: {
            attributes: { ...onboardingPreviewPayload },
            type: 'payments-onboarding_order_previews',
          },
        }
      )
      .then((res: AxiosResponse<TAPICreateOnboardingPreviewResponse>) => {
        if (res.status === 200) {
          return {
            recipePriceBeforeDiscount:
              res.data.data.attributes.recipe_purchase_value,
            recipePriceWithDiscount:
              res.data.data.attributes.recipe_external_payment_amount,
            shippingPrice: res.data.data.attributes.recipe_shipping_amount,
            discountedAmount: res.data.data.attributes.recipe_discount_amount,
            regularShippingPrice:
              res.data.data.attributes.recipe_standard_shipping_amount,
          }
        }
      })
      .catch((err) => {
        errorHandler(err)
        return null
      })
  }
}
